import { FirebaseFirestore } from '@capacitor-firebase/firestore';
import type { DbUser } from '@hub/common';

export async function updateUser(
  userId: string,
  updatedProperties: Partial<DbUser>
): Promise<void> {
  await FirebaseFirestore.updateDocument({
    reference: `userData/${userId}`,
    data: updatedProperties,
  });
}
